module.exports = __webpack_public_path__ + "img/care.01f35a7a.svg";